module.exports = "<button id=\"minimizerToState\" (click)=\"minimizer()\" [ngStyle]=\"{'background-color': colors.sidebarColor}\" class=\"sidebar-minimizer\" type=\"button\" appSidebarMinimizer appBrandMinimizer></button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module id = ./src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module chunks = main